import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { injectStrategyWarningProvider } from "@front/m19-services";
import { StrategyPageService } from "@m19-board/strategies/strategy-page/strategy-page.service";
import { toObservable, toSignal } from "@angular/core/rxjs-interop";
import { switchMap } from "rxjs";
import { IAlertComponent } from "@front/m19-ui";

@Component({
  selector: "app-strategy-page-warning",
  imports: [IAlertComponent],
  template: `@if (strategyWarning() && strategyWarning()?.longDescription) {
    <IAlert class="mt-3 block" [type]="strategyWarning()?.alertType === 'warning' ? 'warning' : 'error'">
      {{ strategyWarning()?.longDescription }}
    </IAlert>
  }`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyPageWarningComponent {
  private readonly strategyPageService = inject(StrategyPageService);
  private readonly warningProvider = injectStrategyWarningProvider();
  private readonly strategy$ = toObservable(this.strategyPageService.strategy);

  strategyWarning = toSignal(
    this.strategy$.pipe(switchMap((strategy) => this.warningProvider.getStrategyWarning(strategy))),
  );
}
